import Achi13AuLogo from '@/assets/image/embeddings/achi13au.svg';
import Icd10AmLogo from '@/assets/image/embeddings/icd10am.svg';
import Icd10CmLogo from '@/assets/image/embeddings/icd10cm.svg';
import Icd10UkLogo from '@/assets/image/embeddings/icd10uk.svg';
import MbsAuLogo from '@/assets/image/embeddings/mbsau.svg';
import Opcs410UkLogo from '@/assets/image/embeddings/opcs410uk.svg';
import SnomedLogo from '@/assets/image/embeddings/snomed.svg';
import { CodeSystem } from '@heidi/coding/contracts';
import { CodeSquare } from 'lucide-react';
import Image from 'next/image';
import { CODE_SYSTEM_CONFIG } from '../constants/clinical-coding';

interface CodeSystemLogoProps {
  codeSystem: CodeSystem;
  height?: number;
}

export const CodeSystemLogo = ({ codeSystem, height = 8 }: CodeSystemLogoProps) => {
  switch (codeSystem) {
    case CodeSystem.snomed_uk:
      return <Image src={SnomedLogo} alt="SNOMED" height={height} />;
    case CodeSystem.icd_10_cm:
      return <Image src={Icd10CmLogo} alt="ICD-10-CM" height={height} />;
    case CodeSystem.mbs_au:
      return <Image src={MbsAuLogo} alt="MBS-AU" height={height} />;
    case CodeSystem.icd_10_am:
      return <Image src={Icd10AmLogo} alt="ICD-10-AM" height={height} />;
    case CodeSystem.achi_13_au:
      return <Image src={Achi13AuLogo} alt="ACHI-13-AU" height={height} />;
    case CodeSystem.icd_10_uk:
      return <Image src={Icd10UkLogo} alt="ICD-10-UK" height={height} />;
    case CodeSystem.opcs410_uk:
      return <Image src={Opcs410UkLogo} alt="OPCS-410-UK" height={height} />;
    case CodeSystem.icd_9_cm:
    case CodeSystem.icd_9_ca:
    case CodeSystem.cpt_2025:
    case CodeSystem.cpt_2026:
    case CodeSystem.icd_10_gm:
    case CodeSystem.cim_10_fr:
    case CodeSystem.cie_10_es:
    case CodeSystem.orpha:
    case CodeSystem.cim_10_mc:
    case CodeSystem.cim_10_scp:
    case CodeSystem.icd_10_za:
    case CodeSystem.ohip_dx:
    case CodeSystem.icd_10_qa:
    case CodeSystem.icd_10_it:
    case CodeSystem.cpt_qa:
      return (
        <div
          className="text-[10px] font-extrabold leading-none"
          style={{ maxHeight: height }}
        >
          {CODE_SYSTEM_CONFIG[codeSystem]?.name}
        </div>
      );
    default:
      return <CodeSquare size={height * 1.75} />;
  }
};

export default CodeSystemLogo;
